import React from 'react'
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <>
      <footer class="relative z-10 pb-17.5 lg:pb-22.5 xl:pb-27.5">
{/* 
        <div class="absolute bottom-0 left-50 w-full flex flex-col gap-3 -z-1 opacity-50">
          <div class="w-full h-[1.24px] footer-bg-gradient"></div>
          <div class="w-full h-[2.47px] footer-bg-gradient"></div>
          <div class="w-full h-[3.71px] footer-bg-gradient"></div>
          <div class="w-full h-[4.99px] footer-bg-gradient"></div>
          <div class="w-full h-[6.19px] footer-bg-gradient"></div>
          <div class="w-full h-[7.42px] footer-bg-gradient"></div>
          <div class="w-full h-[8.66px] footer-bg-gradient"></div>
          <div class="w-full h-[9.90px] footer-bg-gradient"></div>
          <div class="w-full h-[13px] footer-bg-gradient"></div>
        </div> */}

        <div class="max-w-[1170px] mx-auto px-4 sm:px-8 xl:px-0 relative pt-17.5">
          <div class="w-full h-[1px] footer-divider-gradient absolute top-0 left-0"></div>

          <div class="flex flex-wrap justify-between ">
            <div class="w-full lg:w-1/4 items-center mb-18 max-w-[600px] justify-start">
            <Link to="/">
            <img src={require('../images/logo/logo1.svg').default} alt="Logo" />
          </Link>

              <p class="mb-12 xl:w-4/5">
              Intelligent Diagram Assistance
              </p>

              <div class="flex items-center gap-5">


                <a href="https://twitter.com/intellevoAI" target='_blank' class="hover:text-white ease-in duration-300">
                <img src={require("../images/logo/twit.svg").default}/>

                  {/* <svg class="fill-current" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M7.6125 21.5251C16.4625 21.5251 21.2625 14.2126 21.2625 7.87509C21.2625 7.72509 21.2625 7.46259 21.225 7.23759C22.1625 6.56259 22.9875 5.70009 23.625 4.76259C22.725 5.17509 21.825 5.40009 20.8875 5.51259C21.9 4.91259 22.65 3.97509 22.9875 2.8501C22.05 3.3751 21.075 3.78759 19.9125 4.01259C19.0125 3.0751 17.8125 2.4751 16.425 2.4751C13.7625 2.4751 11.5875 4.65009 11.5875 7.31259C11.5875 7.68759 11.625 8.06259 11.7 8.43759C7.8375 8.17509 4.3125 6.26259 1.9125 3.3751C1.5 4.12509 1.275 4.91259 1.275 5.77509C1.275 7.46259 2.1375 8.88759 3.45 9.75009C2.6625 9.71259 1.9125 9.48759 1.275 9.15009C1.275 9.18759 1.275 9.18759 1.275 9.18759C1.275 11.4751 2.925 13.4626 5.1 13.9126C4.6875 14.0251 4.2375 14.0626 3.9 14.0626C3.6 14.0626 3.2625 14.0251 3 13.9501C3.6375 15.8626 5.4 17.2501 7.5 17.2876C5.85 18.5626 3.7875 19.3501 1.575 19.3501C1.125 19.4251 0.75 19.3501 0.375 19.3126C2.4 20.7376 4.9125 21.5251 7.6125 21.5251Z"
                      fill="" />
                  </svg> */}
                </a>

                <a href="https://www.linkedin.com/company/intellevo-ai" target='_blank' class="hover:text-white ease-in duration-300">
                <img src={require("../images/logo/linked.svg").default}  />
                   {/* <svg class="fill-current" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> */}
                     {/* <rect width="24" height="24" fill="#F4F4F4" />
                    <g clip-path="url(#clip0_368_11839)">
                      <path d="M12 25 23.3248C8.9625 23.4373 9.15 23.0623 9.15 22.7998C9.15 22.5373 9.15 21.7873 9.1125 20.7748C5.8875 21.5248 5.2125 19.1998 5.2125 19.1998C4.6875 17.8873 3.9 17.5123 3.9 17.5123C2.85 16.7623 3.9375 16.7623 3.9375 16.7623C5.1 16.7998 5.7375 17.9623 5.7375 17.9623C6.75 19.7623 8.475 19.2373 9.1125 18.8998C9.225 18.1498 9.525 17.6248 9.8625 17.3248C7.3125 17.0623 4.575 16.0498 4.575 11.6248C4.575 10.3498 5.0625 9.3373 5.775 8.5498C5.6625 8.2873 5.25 7.0873 5.8875 5.4748C5.8875 5.4748 6.9 5.1748 9.1125 6.6748C10.05 6.4123 11.025 6.2623 12.0375 6.2623C13.05 6.2623 14.0625 6.3748 14.9625 6.6748C17.175 5.2123 18.15 5.4748 18.15 5.4748C18.7875 7.0498 18.4125 8.2873 18.2625 8.5498C19.0125 9.3373 19.4625 10.3873 19.4625 11.6248C19.4625 16.0498 16.725 17.0623 14.175 17.3248C14.5875 17.6998 14.9625 18.4498 14.9625 19.4998C14.9625 21.0748 14.925 22.3123 14.925 22.6873C14.925 22.9873 15.15 23.3248 15.7125 23.2123C20.2875 21.6748 23.625 17.3623 23.625 12.2248C23.5875 5.8498 18.375 0.674805 12 0.674805Z" fill="#0077B5" />
                    </g>
                    <g clip-path="url(#clip0_368_11839)">
                      <path d="M21.9778 0H2.021C0.9051 0 0 0.903857 0 2.01725V21.9827C0 23.0961 0.9051 24 2.021 24H21.9778C23.0928 24 24 23.0961 24 21.9827V2.01725C24 0.903857 23.0928 0 21.9778 0ZM7.9746 21.9757H4.01636V9.81641H7.9746V21.9757ZM5.9955 8.58849H5.99275C4.79259 8.58849 4.01636 7.81641 4.01636 6.79439C4.01636 5.74706 4.7936 4.9757 5.99453 4.9757C7.19545 4.9757 7.97168 5.74778 7.9746 6.79439C7.9746 7.81641 7.19617 8.58849 5.9955 8.58849ZM20.0132 21.9757H16.0549V15.6694C16.0549 13.9864 15.9831 11.8743 14.0469 11.8743C12.0849 11.8743 11.9492 13.6449 11.9492 15.5675V21.9757H8.001V9.81641H11.9492V11.6174H11.9826V11.6174C12.4091 10.7664 13.3611 9.4727 15.3961 9.4727C18.4282 9.4727 19.9766 11.8743 19.9766 15.3147V21.9757H20.0132Z" fill="#0077B5" />
                    </g>
                    <defs>
                    </defs>  */}
                  {/* </svg>  */}

                  
                  </a>

                  <a href="https://www.instagram.com/intellevo.ai" target='_blank' class="hover:text-white ease-in duration-300">
                <img src={require("../images/logo/Insta.svg").default}  />
                </a>
              </div>

              <p class="font-medium mt-5.5">
              ⓒ 2025 Intellevo AI, Inc.
              </p>
            </div>

            <div class="max-w-[571px] w-full">
              <div class="flex flex-col sm:flex-row sm:justify-between gap-10">
                <div>
                  <h5 class="font-semibold text-white mb-5">Products</h5>

                  <ul class="flex flex-col gap-3.5">
                    <li>
                      <a href="/#features" class="font-medium ease-in duration-300 hover:text-white">Features</a>
                    </li>
                    {/* <li>
                      <a href="/#" class="font-medium ease-in duration-300 hover:text-white">Integrations</a>
                    </li>
                    <li>
                      <a href="/#" class="font-medium ease-in duration-300 hover:text-white">Pricing</a>
                    </li>
                    <li>
                      <a href="/#" class="font-medium ease-in duration-300 hover:text-white">Changelog</a>
                    </li>
                    <li>
                      <a href="/#" class="font-medium ease-in duration-300 hover:text-white">Roadmap</a>
                    </li> */}
                  </ul>
                </div>

                <div>
                  <h5 class="font-semibold text-white mb-5">Company</h5>

                  <ul class="flex flex-col gap-3.5">
                    {/* <li>
                      <a href="/#" class="font-medium ease-in duration-300 hover:text-white">Privacy Policy</a>
                    </li>
                    <li>
                      <a href="/#" class="font-medium ease-in duration-300 hover:text-white">Refund Policy</a>
                    </li> */}
                    <li>
                      <a href="/#support" class="font-medium ease-in duration-300 hover:text-white">Support</a>
                    </li>
                    {/* <li>
                      <a href="/#" class="font-medium ease-in duration-300 hover:text-white">Community</a>
                    </li> */}
                  </ul>
                </div>

                <div>
                  <h5 class="font-semibold text-white mb-5">Support</h5>

                  <ul class="flex flex-col gap-3.5">
                    {/* <li>
                      <a href="/#" class="font-medium ease-in duration-300 hover:text-white">Features</a>
                    </li>
                    <li>
                      <a href="/#" class="font-medium ease-in duration-300 hover:text-white">Integrations</a>
                    </li> */}
                    <li>
                      <a href="/#pricing" class="font-medium ease-in duration-300 hover:text-white">Pricing</a>
                    </li>
                    {/* <li>
                      <a href="/#" class="font-medium ease-in duration-300 hover:text-white">Changelog</a>
                    </li> */}
                    {/* <li>
                      <a href="/#" class="font-medium ease-in duration-300 hover:text-white">Roadmap</a>
                    </li> */}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      {/* ====== Footer Section End */}
    </>
  )
}

export default Footer